import styled, { keyframes } from "styled-components";

// Yükleme animasyonu için keyframes tanımlaması
const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Loader stilini tanımlıyoruz
const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.fullscreen ? "100vh" : "auto"};
  position: ${(props) => props.fullscreen ? "fixed" : "relative"};
  z-index: 10999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 109, 156, 0.2) 0%, rgba(104, 55, 115, 0.2) 100%);

`;

const Spinner = styled.div`
  border: 4px solid ${(props) => props.theme.colors.light || "#f3f3f3"};
  border-top: 4px solid ${(props) => props.theme.colors.primary || "#3498db"};
  border-radius: 50%;
  width: ${(props) => props.size || "50px"};
  height: ${(props) => props.size || "50px"};
  animation: ${spin} 1s linear infinite;
`;

const LoaderText = styled.p`
  margin-top: 10px;
  font-size: 1rem;
  color: ${(props) => props.theme.colors.text.light || "#333"};
`;

const Loader = ({ size, fullscreen, text }) => {
  return (
    <LoaderWrapper fullscreen={fullscreen}>
      <Spinner size={size} />
      {text && <LoaderText>{text}</LoaderText>}
    </LoaderWrapper>
  );
};

export default Loader;
